import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class VersionCheckService {
    // this will be replaced by actual hash post-build.js
    private currentHash = "56";

    constructor(private http: HttpClient) {}

    /**
     * Checks in every set frequency the version of frontend application
     * @param url
     * @param {number} frequency - in milliseconds, defaults to 10 minutes
     */
    public initVersionCheck(url: any, frequency = 1000 * 60 * 60 * 1) {
        setInterval(() => {
            this.checkVersion(url);
        }, frequency);
    }

    /**
     * Will do the call and check if the hash has changed or not
     * @param url
     */
    private checkVersion(url: string) {
        // timestamp these requests to invalidate caches
        this.http.get(url)
        .subscribe(
                (response: any) => {
                    console.log("Checking version!");
                    const hash = response.hash;
                    const hashChanged = this.hasHashChanged(this.currentHash, String(hash));

                     // If new version, do something
                    if (hashChanged) {
                        location.reload();
                        console.log("cache cleared! ");
                    }
                    // store the new hash so we wouldn't trigger versionChange again
                    // only necessary in case you did not force refresh
                    this.currentHash = hash;
                },
                (err: any) => {
                    console.error(err, 'Could not get version');
                }
            );
    }

    /**
     * Checks if hash has changed.
     * This file has the JS hash, if it is a different one than in the version.json
     * we are dealing with version change
     * @param currentHash
     * @param newHash
     * @returns {boolean}
     */
    private hasHashChanged(currentHash: string, newHash: string) {
        return currentHash.toString().trim() !== newHash.toString().trim();
    }
}